// extracted by mini-css-extract-plugin
export default {"message":"StorageLimitModal__message__W0MQc"};